/* eslint-disable no-console */
// @flow
import env from './env';

export function logError(error: Error, errorInfo: any): void {
  console.log(error, errorInfo);
}

export function redirectToMaintenance(): void {
  window.location.replace(`https://${env.hostname}/oops/maintenance`);
}
